var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Emit, PropSync, Vue, Component } from 'vue-property-decorator';
import Modal from '@/components/Modal.vue';
import { acceptTermsOfWhatsappEnrichment } from '@/clients/enrichment_whatsapp';
let WhatsappEnrichmentTermsOfUse = class WhatsappEnrichmentTermsOfUse extends Vue {
    closeModal() {
        return;
    }
    async confirm() {
        try {
            await acceptTermsOfWhatsappEnrichment();
            this.$emit('agree');
        }
        catch (e) {
            console.log(e);
        }
    }
};
__decorate([
    PropSync('open', { default: false })
], WhatsappEnrichmentTermsOfUse.prototype, "showModal", void 0);
__decorate([
    Emit('cancel')
], WhatsappEnrichmentTermsOfUse.prototype, "closeModal", null);
WhatsappEnrichmentTermsOfUse = __decorate([
    Component({
        name: 'WhatsappEnrichmentTermsOfUse',
        components: { Modal },
    })
], WhatsappEnrichmentTermsOfUse);
export default WhatsappEnrichmentTermsOfUse;
